import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import InsuranceProviderDetails from './InsuranceProviderDetails';
import { deleteInsuranceProvider } from '../../../../services/clinicPortalServices/insuranceProviderSerivce';
import { getUserRole } from '../../../../services/common/util';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            insuranceProviderId: props.data._id,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const provider = this.props.data;
        if (provider) {
            trackRecentView('insurance_provider', provider._id, provider.name || 'Insurance Provider', '/clinic/insuranceProvider');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this insurance provider!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const insuranceProviderInfo = {
                    _id: this.state.insuranceProviderId,
                    name: this.props.data.name
                };
                deleteInsuranceProvider(insuranceProviderInfo).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderPanel() {
        const d = this.props.data;
        const ps = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };
        const address = [d.address1, d.address2, d.city, d.state, d.zip].filter(Boolean).join(', ');
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Insurance Provider Details</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Provider Information</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Name</dt><dd style={ps.dd}>{d.name || '—'}</dd>
                                <dt style={ps.dt}>Code</dt><dd style={ps.dd}>{d.code || '—'}</dd>
                                <dt style={ps.dt}>Phone</dt><dd style={ps.dd}>{d.phone || '—'}</dd>
                            </dl>
                        </div>
                        {address && <div style={ps.section}><div style={ps.sectionTitle}>Address</div><div style={{ fontSize: '13px', color: '#222' }}>{address}</div></div>}
                    
                        <RecordDetails data={d} exclude={['address1', 'address2', 'city', 'code', 'name', 'phone', 'state', 'zip', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Insurance Provider
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Insurance Provider
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Insurance Provider</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn"><i className="fas fa-eye"></i></button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                {/superadmin/.test(getUserRole().toLowerCase()) && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                        <button onClick={this.handleDelete} className="edit-order-btn">
                            <i className="fas fa-trash"></i>
                        </button>
                    </OverlayTrigger>
                )}

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Insurance Provider Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InsuranceProviderDetails
                            insuranceProviderId={this.state.insuranceProviderId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
